module.exports = __webpack_public_path__ + "static/media/pdf-file.a6a0e2d9.svg";